/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Cat_Unstarted_HintInputs */

const en_sch_cat_unstarted_hint = /** @type {(inputs: Sch_Cat_Unstarted_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planned and ready to be picked up.`)
};

const de_sch_cat_unstarted_hint = /** @type {(inputs: Sch_Cat_Unstarted_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geplant und bereit zum Start.`)
};

/**
* | output |
* | --- |
* | "Planned and ready to be picked up." |
*
* @param {Sch_Cat_Unstarted_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_cat_unstarted_hint = /** @type {((inputs?: Sch_Cat_Unstarted_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Cat_Unstarted_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_cat_unstarted_hint(inputs)
	return en_sch_cat_unstarted_hint(inputs)
});